import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'src/utils/translate';
import footfallEventTypes from 'src/constants/footfallEventTypes';
import PostListCard from 'src/modules/community/shared/components/sidebar/postListCard';
import { trackFootfallEventWithHrefDelay } from 'src/utils/footfall';

const CommunityHomePinnedPosts = ({ posts, community }) => (
  <PostListCard
    community={community}
    posts={posts}
    postType={'pinned-post'}
    seeAllLink={`/${community.slug}/posts/#pinned`}
    seeAllOnClick={e => {
      e.preventDefault();
      trackFootfallEventWithHrefDelay(`/${community.slug}/posts/#pinned`, footfallEventTypes.CLICKED, {
        clickType: 'see-all-pinned-posts',
        clickMetadata: { section: 'community-home-side-bar' },
      });
    }}
    title={i18n.t('Pinned Posts')}
  />
);

CommunityHomePinnedPosts.propTypes = {
  community: PropTypes.object.isRequired,
  posts: PropTypes.array,
};

CommunityHomePinnedPosts.defaultProps = {
  posts: [],
};

export default CommunityHomePinnedPosts;
